module.exports = __webpack_public_path__ + "img/SportPlaceholderMobileSquare.762ecc9a.svg";